export const PRODUCT_TYPE_TICKET = 'Ticket';
export const PRODUCT_TYPE_HOSPITALITY = 'Hospitality';
export const PRODUCT_TYPE_PARKING = 'Parking';
export const PRODUCT_TYPE_EXTRAS = 'Extras';
export const PRODUCT_TYPE_PARKING_STANDALONE = 'Parking Standalone';

export const PRODUCT_TAG_ADULT = 'Adult';
export const PRODUCT_TAG_YOUTH = 'Youth';
export const PRODUCT_TAG_JUNIOR = 'Junior';
export const PRODUCT_TAG_CAR = 'CarParking';
export const PRODUCT_TAG_MOTORCYCLE = 'MotorcycleParking';
export const PRODUCT_TAG_COACH = 'CoachParking';
export const PRODUCT_TAG_MINIBUS = 'MinibusParking';
export const PRODUCT_TAG_EXTRAS = 'Extras';
export const PRODUCT_TAG_SWING_BADGE = 'SwingBadge';
export const PRODUCT_TAG_SWING_BADGE_GUEST = 'SwingBadgeGuest';
export const PRODUCT_TAG_SWING_BADGE_ADDITIONAL_GUEST = 'SwingBadgeAdditionalGuest';

export const MAX_STANDART_TICKETS = 4;
export const MAX_STANDART_TICKETS_AVAILABLE = 4;
export const MAX_HOSPITALITY_TICKETS = 10;
export const MAX_HOSPITALITY_TICKETS_AVAILABLE = 10;
export const MAX_SWING_BADGE_AVAILABLE = 1;
export const MAX_SWING_BADGE_GUEST_AVAILABLE = 1;
export const MAX_SWING_BADGE_ADDITIONAL_GUEST_AVAILABLE = 2;
export const MAX_HOSPITALITY_TICKET_PLUS = 4;
export const MAX_HOSPITALITY_TICKET_PLUS_EXTRA = 1;

export const PRODUCT_TAG_1860 = '1860';
export const PRODUCT_TAG_PLATINUM = 'Platinum';
export const PRODUCT_TAG_PREMIUM = 'Premium';
export const PRODUCT_TAG_SELECT = 'Select';
export const PRODUCT_TAG_SIGNATURE = 'Signature';

export const PRODUCT_TAG_SCORERS_PREMIUM = 'ScorersPremium';
export const PRODUCT_TAG_ENGRAVERS = 'Engravers';
export const PRODUCT_TAG_CHAMPIONS = 'Champions';
export const PRODUCT_TAG_TICKET_PLUS = 'TicketPlus';
export const PRODUCT_TAG_TICKET_PLUS_EXTRA = 'TicketPlusExtra';
export const PRODUCT_SECUTIX_ID_ENGRAVERS_SUNDAY = '101322505327';
export const MAX_SCORERS_PREMIUM_TICKETS_AVAILABLE = 10;

export const HOSPITALITY_PRODUCTS = {
    [PRODUCT_TAG_1860]: {
        maxQuantity: 20,
        quantityMultiplier: 1
    },
    [PRODUCT_TAG_PLATINUM]: {
        maxQuantity: 20,
        quantityMultiplier: 1
    },
    [PRODUCT_TAG_PREMIUM]: {
        maxQuantity: 20,
        quantityMultiplier: 1
    },
    [PRODUCT_TAG_SELECT]: {
        maxQuantity: 6,
        quantityMultiplier: 1
    },
    [PRODUCT_TAG_SIGNATURE]: {
        maxQuantity: 20,
        quantityMultiplier: 1
    },
    [PRODUCT_TAG_CHAMPIONS]: {
        maxQuantity: 10,

        // this quantity multiplier must be in-sync with the
        // quantity modifier value from the ticket builder
        // setting in Sitecore for Champions packages
        quantityMultiplier: 2
    }
};

export const BASKET_STORAGE_KEY = 'ticketBasket2019';
export const BALLOT_BASKET_STORAGE_KEY = 'ticketBasketBallot';
export const BASKET_DATE_CREATED_KEY = 'ticketBasket2019DateCreated';
export const BALLOT_BASKET_DATE_CREATED_KEY = 'ticketBallotBasketDateCreated';
export const BALLOT_RESERVED_PRODUCTS_STORAGE_KEY = 'ballotReservedProducts';
export const BALLOT_ORDER_FILE_NUMBER_COOKIE_NAME = 'ballotOrdersFileNumber';
// 30 days
export const BASKET_TTL_MS = 2592000000;

export const CHECKOUT_URL_KEY = 'checkoutUrl';
export const DEFAULT_BASKET = {
    productGroups: {},
    isEmpty: true
};
